
import {ValueListener} from "../eventDataSourceUpgrades/interfaces";
import {loginManager} from "../auth/loginManager";



/**
 * Given a people class instance find the person with the given userId, return null if not found.
 * @param people
 * @param userId
 * @returns {null}
 */
var findPersonWithUserId = function (people, userId) {
    if (!userId) {
        return null;
    }

    var personKeys = people.getKeys().filter(function (personKey) {
        var person = people.getPersonAtKey(personKey);
        var userProfileKeys = person.userProfileKeys || [];
        return (userProfileKeys.indexOf(userId) >= 0);
    });

    if (!personKeys.length) {
        return null;
    }

    return people.getPersonAtKey(personKeys[0]);
};


class EventPerson {
    private _ds: any;
    private _listener: ValueListener<any>;
    private _spotlight: any;
    private _people: any;
    private _lastUserId: string | null;

    constructor(eventDataSource: any, listener: ValueListener<any>) {
        var This = this;
        This._ds = eventDataSource;
        if (typeof listener == "function") {
            listener = {
                onValue: listener
            };
        }
        This._listener = listener;

        var onPersonChanged = This._onPersonChanged.bind(This);
        This._spotlight = eventDataSource.getCurrentPersonSpotlight({
            onValue: onPersonChanged
        });

        This._people = This._ds.getPeople({
            onChildAdded: onPersonChanged,
            onChildChanged: onPersonChanged,
            onChildRemoved: onPersonChanged
        });

        this._lastUserId = null;

        const loginMightHaveChanged = () => {
            return loginManager.getUserId()
                .then((userId) => {
                    if (this._lastUserId !== userId) {
                        this._lastUserId = userId;
                        onPersonChanged();
                    }
                });
        };

        loginManager.activeAuthObservable().subscribe(loginMightHaveChanged);
        loginManager.loginIfPossible().then(loginMightHaveChanged);

        onPersonChanged();
    }


    /**
     * Look at the spotlight and the logged in user and try and find a person
     * who can become the target for rsvp
     * @returns {*}
     */
    _getBestGuessForTargetPerson() {
        var This = this;

        var loggedInUserId = this._lastUserId;

        var targetPerson = null;
        if (loggedInUserId) {
            //using This._spotlight._people instead of _people, bc the spotlight's people class has a hack to always have an empty profile for the logged in user
            targetPerson = findPersonWithUserId(This._spotlight._people, loggedInUserId);
        }
        if (!targetPerson) {
            targetPerson = This._spotlight.getCurrentPerson();
        }

        return targetPerson;
    }

    _onPersonChanged() {
        var This = this;
        var targetPerson = This._getBestGuessForTargetPerson();
        setImmediate(function () {
            var onValue = This._listener.onValue;
            onValue(targetPerson);
        });
    }

    isLoginless() {
        return !loginManager.isLoggedIn();
    }
};


export default EventPerson;

